import React from 'react';
import { map, isEmpty, noop, find, get, times, toString } from 'lodash';
import classnames from 'classnames';

import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { CREDIT_CARD_TYPE } from 'constants/entity-names';
import { SingleSelect } from 'modules/singleSelect';
import { GLOBAL_LABELS } from 'constants/common';
import { checkbox as Checkbox } from 'ui/views/generic/checkbox';
import { hsaFsaIndicator as HsaFsaIndicator } from 'ui/views/widgets/hsaFsaIndicator';

// import { isVisible } from 'resolvers/getVisibleEntities';

// card type icons
const CARD_TYPE_ICON = {
    [ CREDIT_CARD_TYPE.CREDIT_VISA ]: 'visaCard',
    [ CREDIT_CARD_TYPE.MASTER_CARD ]: 'masterCard',
    [ CREDIT_CARD_TYPE.AMERICAN_EXPRESS ]: 'amexCard',
    [ CREDIT_CARD_TYPE.DISCOVER ]: 'discoverCard',
    [ CREDIT_CARD_TYPE.DEBIT_VISA ]: 'visaCard',
    [ CREDIT_CARD_TYPE.DEBIT_MASTER_CARD ]: 'masterCard'
};

const PaymentCard = ( props ) => {

    const { card, actions, enableSelection } = props;

    // check if card is selected as default
    const isDefault = get( card, 'flags.isDefault', false );

    // get Default action
    const setDefault = find( actions, { name: 'setDefault' } );

    // check if set Default action is allowed
    const canSetDefault = get( card, 'actionsVisibility.setDefault', false );

    // edit action
    const editAction = find( actions, { name: 'edit' } );
    const canEdit = get( card, 'actionsVisibility.edit', false );

    // check if card is activated
    const isActivated = get( card, 'flags.isActivated', true );

    // activate action
    const activateAction = find( actions, { name: 'activate' } );
    const canActivate = get( card, 'actionsVisibility.activate', false );

    // inactivate action
    const inactivateAction = find( actions, { name: 'inactivate' } );
    const canInactivate = get( card, 'actionsVisibility.inactivate', false );

    // check hsaFsa status of card
    const isHsaFsaEnabled = get( card, 'flags.isHsaFsa', false );

    // hsaFsa action toggle
    const hsaFsaAction = find( actions, { name: 'hsaFsa' } );
    const canToggleHsaFsa = get( card, 'actionsVisibility.hsaFsa', false );
    
    const defaultSectionClass = classnames( 'ui-member-payment-card__header__default', {
            'ui-member-payment-card__header__default--highlight': isDefault,
            'ui-member-payment-card__header__default--disabled': ! isActivated
        }
    );

    const className = classnames( 'ui-member-payment-card', {
        'ui-member-payment-card--selected': props.enableSelection && isActivated && get( card, 'selected', false ),
        'ui-member-payment-card--inactivated': ! isActivated
        
        // 'ui-member-payment-card--disabled': props.disabled
    } );

    const titleClassName = classnames( 'ui-member-payment-card__header__title', {
        'ui-member-payment-card__header__title--action': enableSelection && isActivated
    } );

    const edtActionClassName = classnames( 'ui-member-payment-card__footer__actions__action', {
        'ui-member-payment-card__footer__actions__action--disabled': ! canEdit,
    } );

    const activateActionClassName = classnames( 'ui-member-payment-card__footer__actions__action', {
        'ui-member-payment-card__footer__actions__action--disabled': ! canActivate
    } );

    const inactivateActionClassName = classnames( 'ui-member-payment-card__footer__actions__action', {
        'ui-member-payment-card__footer__actions__action--disabled': ! canInactivate
    } );

    const hsaFsaActionClassName = classnames( 'ui-member-payment-card__footer__actions__action', {
        'ui-member-payment-card__footer__actions__action--disabled': ! canToggleHsaFsa,
    } );

    let isDefaultVisible = false;
    if ( !isEmpty( get( props, 'defaultDescription', {} ) ) ) {
        isDefaultVisible = true;
    }

    return (
        <div className={ className }>

            {/* card header view */}
            <div className='ui-member-payment-card__header'>

                {/* card name */}
                <div className={ titleClassName } onClick={ () => enableSelection && isActivated ? props.onSelectActionClick( { card } ) :noop }>
                    { enableSelection && isActivated && (
                        <RadioBox selected={ get( card, 'selected', false ) } />
                    ) }
                    { card.name }
                </div>

                { canSetDefault ? (
                    <div className={ defaultSectionClass } onClick={ () => {
                        ( canSetDefault && ! isDefault && isActivated ) ? props.onSetDefaultClick( { card } ): noop;
                    } } >
                        { getLabel( get( setDefault, 'title', {} ) ) }
                    </div>
                ) : null }
                
            </div>

            {/* card body view */}
            <div className='ui-member-payment-card__body'>
                <span className='ui-member-payment-card__body__star'>**** **** ****</span>
                <span className='ui-member-payment-card__body__card-detail'>{ card.lastDigits }</span>
            </div>

            {/* card footer view */}
            <div className='ui-member-payment-card__footer'>
                <div className='ui-member-payment-card__footer__expiry'>

                    <div className='ui-member-payment-card__footer__expiry__label'>
                        <div className='ui-member-payment-card__footer__expiry__label__title'>
                            <div className='ui-member-payment-card__footer__expiry__label__title__expiry'>
                                { getLabel( GLOBAL_LABELS.DISPLAY_TEXT_EXP_DATE ) }
                            </div>

                            {/* card type */}
                            <div className='ui-member-payment-card__footer__expiry__label__title__card-type'>
                                <Icon id={ CARD_TYPE_ICON[ card.type ] } />
                            </div>
                        </div>
                    </div>
                </div>

                {
                    isEmpty( hsaFsaAction ) ? null : (
                        <HsaFsaIndicator
                            { ...hsaFsaAction }
                            isHsaFsaEnabled = { isHsaFsaEnabled }
                            className = { hsaFsaActionClassName }
                            onChange={ () => ! canToggleHsaFsa ? null : props.onHsaFsaActionClick( { url: hsaFsaAction.url, card } ) }
                        />
                    )
                }


            </div>

            <div className='ui-member-payment-card__footer__actions__container'>
                {/* read/edit mode */}
                {
                    props.displayEditMode ? (
                        <div className='ui-member-payment-card__footer__expiry__label__value-edit'>
                            <div className='ui-member-payment-card__footer__expiry__label__value-edit__selection'>
                                <div className='ui-member-payment-card__footer__expiry__label__value-edit__selection__item'>
                                    <SingleSelect
                                        className='ui-member-payment-card__footer__expiry__label__value-edit__selection__item__dropdown'
                                        options={ map( times( 12 ), index => {
                                            const value = 9 < ( index + 1 ) ? index + 1 : `0${ index + 1 }`;
                                            return { name: toString( value ), value: toString( value ), title: { refId: '', value: toString( value ) } };
                                        } ) }
                                        popupWidth={ 100 }
                                        value={ props.editingExpiryMonth }
                                        onChange={ ( { value } ) => props.onCardMonthSelect( { card, value } ) }
                                    />
                                </div>
                                <div className='ui-member-payment-card__footer__expiry__label__value-edit__selection__item'>
                                    <SingleSelect
                                        className='ui-member-payment-card__footer__expiry__label__value-edit__selection__item__dropdown'
                                        options={ map( times( 10 ), index => ( { name: toString( index + 21 ), value: toString( index + 21 ), title: { refId: '', value: toString( index + 21 ) } } ) ) }
                                        popupWidth={ 100 }
                                        value={ props.editingExpiryYear }
                                        onChange={ ( { value } ) => props.onCardYearSelect( { card, value } ) }
                                    />
                                </div>
                            </div>
                            <div className='ui-member-payment-card__footer__expiry__label__value-edit__actions'>
                                <div className='ui-member-payment-card__footer__expiry__label__value-edit__actions__item' onClick={ () => props.onSubmitEditedCardDetails( { card } ) }>
                                    <Icon id='checkmark' width='10' height='10' fill='#ffffff'/>
                                </div>
                                <div className='ui-member-payment-card__footer__expiry__label__value-edit__actions__item' onClick={ () => props.onCancelEdit() }>
                                    <Icon id='cross' width='10' height='10' fill='#ffffff'/>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className='ui-member-payment-card__footer__expiry__label__value'>{ card.expDate }</div>
                    )
                }

                {/* actions */}
                <div className='ui-member-payment-card__footer__actions'>

                    {/* edit */}
                    {
                    
                        ( isEmpty( editAction ) || props.displayEditMode /*|| ! canEdit*/ ) ? null : (
                            <div className={ edtActionClassName } onClick={ () => props.disableActions || ! canEdit ? null : props.onEditActionClick( { url: editAction.url, card, confirmation: editAction.confirmation } ) }>
                                <div className='ui-member-payment-card__footer__actions__action__icon'>
                                    <Icon id={ 'edit' } fill={ canEdit ? THEME.themeColorPrimary2 : '#7a7a7a' } />
                                </div>
                                <span className='ui-member-payment-card__footer__actions__action__label'> { getLabel( get( editAction, 'title', {} ) ) } </span>
                            </div>
                        )
                        
                    }

                    {/* activate */}
                    {
                        ( isActivated || isEmpty( activateAction ) || props.displayEditMode ) ? null : (
                            <div className={ activateActionClassName } onClick={ () => props.disableActions || ! canActivate ? null : props.onActivateActionClick( { url: activateAction.url, card, cardActivationInfo: activateAction.cardActivationInfo } ) }>
                                <div className='ui-member-payment-card__footer__actions__action__icon'>
                                    <Icon id='activateCheck' width='15' height='15' fill={ canActivate ? THEME.themeColorPrimary2 : '#7a7a7a' } />
                                </div>
                                <span className='ui-member-payment-card__footer__actions__action__label'> { getLabel( activateAction.title ) } </span>
                            </div>
                        )
                    }

                    {/* inactivate */}
                    {
                        ( ! isActivated || isEmpty( inactivateAction ) || props.displayEditMode ) ? null : (
                            <div className={ inactivateActionClassName } onClick={ () => props.disableActions || ! canInactivate ? null : props.onInactivateActionClick( { url: inactivateAction.url, card, confirmation: inactivateAction.confirmation } ) }>
                                <div className='ui-member-payment-card__footer__actions__action__icon'>
                                    <Icon id='inactivateCheck' width='12' height='12' fill={ canInactivate ? THEME.themeColorPrimary2 : '#7a7a7a' } />
                                </div>
                                <span className='ui-member-payment-card__footer__actions__action__label'> { getLabel( inactivateAction.title ) } </span>
                            </div>
                        )
                    }
                </div>
            </div>
            
            {
                isDefault && isDefaultVisible ? (
                    <div className='ui-member-payment-card__default' >
                        <div className='ui-member-payment-card__default__icon'>
                            <Icon name='info' width='14' height='14' fill='#ffffff' />
                        </div>
                        <div className='ui-member-payment-card__default__description'>
                            { getLabel( get( props, 'defaultDescription.description', {} ) ) }
                        </div>
                    </div>
                ) : null
            }
        </div>
    );
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberAddEditPaymentInformation as MemberAddEditPaymentInformation } from 'ui/views/widgets/memberAddEditPaymentInformation';
 *
 * // render
 * <MemberAddEditPaymentInformation propName='propValue'/>
 */
export const memberAddEditPaymentInformation = ( props ) => {

    const { paymentOptions, addAction = {}, disabled = false, widgetConfig = {} } = props;

    const bodyClassName = classnames( 'ui-member-add-edit-payment-information__body',  {
        'ui-member-add-edit-payment-information__body--disabled': props.disabled // props.clearSelectionSelected && ! isEmpty( props.clearSelection )
    } );

    // const clearSelectionSelected = 0 < size( paymentOptions ) && ! isUndefined( find( paymentOptions, { selected: true } ) ) ? false : true;

    return (
        <>{ <div className={ 'ui-member-add-edit-payment-information' }>

            {/* widget title */}
            {
                props.displayTitle ? (
                    <div className='ui-member-add-edit-payment-information__header'>
                        <Icon id={ 'paymentCard' } />
                        <div className='ui-member-add-edit-payment-information__header__title'>
                            { getLabel( get( widgetConfig, 'title', {} ) ) }
                        </div>

                        {
                            ! isEmpty( props.clearSelection ) && (
                                <div className='ui-member-add-edit-payment-information__header__clear' onClick={ () => props.onClearSelection() } >

                                    <Checkbox
                                        className='ui-member-add-edit-payment-information__header__clear__checkbox'
                                        value={ props.clearSelectionSelected }
                                        
                                        // onClick={ props.onClearSelection }
                                        size='xs'
                                    />
                                    { getLabel( get( props, 'clearSelection.title' ) ) }
                                </div>
                            )
                        }
                    </div>
                ) : null
            }

            <div className={ bodyClassName }>

                { ! isEmpty( get( props, 'addAction', {} )  ) && (
                    <div className='ui-member-add-edit-payment-information__body__add' onClick={ () => props.onAddActionClick( { url: props.addAction.url } ) }>
                        <Icon id={ 'add' } />
                        <div className='ui-member-add-edit-payment-information__body__add__title'>{ getLabel( addAction.title ) }</div>
                    </div>
                ) }

                { map( paymentOptions, item => {
                    return (
                        <PaymentCard
                            key={ item.id }
                            card={ item }
                            actions={ props.modifyActions }
                            onSetDefaultClick={ props.onSetDefaultClick }
                            onSelectActionClick={ props.onSelectActionClick }
                            onEditActionClick={ props.onEditActionClick }
                            onActivateActionClick={ props.onActivateActionClick }
                            onInactivateActionClick={ props.onInactivateActionClick }
                            onCardMonthSelect={ props.onCardMonthSelect }
                            onCardYearSelect={ props.onCardYearSelect }
                            onCancelEdit={ props.onCancelEdit }
                            onSubmitEditedCardDetails={ props.onSubmitEditedCardDetails }
                            enableSelection={ props.enableSelection }
                            disableActions={ props.isEditing }
                            displayEditMode={ props.isEditing && props.editingCardId === item.id }
                            editingExpiryMonth={ props.editingExpiryMonth }
                            editingExpiryYear={ props.editingExpiryYear }
                            disabled={ disabled }
                            defaultDescription= { props.defaultDescription }
                            onHsaFsaActionClick= { props.onHsaFsaActionClick }
                         />
                    );
                } ) }

                {/* info card view */}
                {
                    !isEmpty( props.infoCard ) ? (
                        <div className={ `${ bodyClassName }__infocard` }>
                            <div className={ `${ bodyClassName }__infocard__icon` }>
                                <Icon name='infoRed' width='14' height='14' fill='#ffffff' />
                            </div>
                            <div className={ `${ bodyClassName }__infocard__description` }>
                                { getLabel( get( props, 'infoCard.description' ) ) }
                            </div>
                        </div>
                    ) : null
                }

            </div>

        </div>}</>
    );
};

// set display name
memberAddEditPaymentInformation.displayName = 'memberAddEditPaymentInformation';

// set default props
memberAddEditPaymentInformation.defaultProps = {
    displayTitle: true
};

// prop types
memberAddEditPaymentInformation.propTypes = {};
